module.exports = __webpack_public_path__ + "img/about_2.269cba74.png";